<div *ngIf="LoadPage">
  <div class="title-components">
    <h1>{{ User.Nombre }}</h1>
  </div>

  <div class="Options-Menu">
    <!---================= CONTAINER SELECT TYPE =================--->

    <div class="Card-Option container-global-components">
      <div class="Icon-Left">
        <div class="Local-Icon-Card button-square">
          <i class="fa-solid fa-users"></i>
        </div>
      </div>

      <div class="Container-Card">
        <div class="Option-Title">
          <h2>Opciones de Rol y grupos</h2>
        </div>

        <div class="Input-Option DisplayInputs">
          <div class="Container-Buttons">
            <button
              (click)="Toggle_Modal_Relation_User(true)"
              class="Btn-Option Add button-square"
            >
              <span class="Tool-Tip">Relacionar usuario al Rol</span>
              <i class="fa-solid fa-plus"></i>
            </button>
            <button
              (click)="Toggle_Modal_Relation_User_Group(true)"
              class="Btn-Option Add button-square"
            >
              <span class="Tool-Tip">Relacionar usuario al grupo</span>
              <i class="fa-solid fa-users"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="Card-Option container-global-components">
      <div class="Icon-Left">
        <div class="Local-Icon-Card button-square">
          <i class="fa-solid fa-hashtag"></i>
        </div>
      </div>

      <div class="Container-Card">
        <div class="Option-Title">
          <h2>Roles del Usuario</h2>
        </div>

        <div class="Input-Option DisplayInputs">
          <div class="Container-Buttons">
            <div class="Generate-Report-Level">
              {{ All_Roles_Of_User.length }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="Card-Option container-global-components">
      <div class="Icon-Left">
        <div class="Local-Icon-Card button-square">
          <i class="fa-solid fa-gear"></i>
        </div>
      </div>

      <div class="Container-Card">
        <div class="Option-Title">
          <h2>Actualizar información</h2>
        </div>

        <div class="Input-Option DisplayInputs">
          <!---================= CONTAINER RELOAD PAGE =================--->
          <div class="Container-Buttons">
            <button (click)="Reload_Page()" class="Btn-Option button-square">
              <span class="Tool-Tip">Recargar pagina</span>
              <i class="fa-solid fa-rotate-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--&================== CONTAINER GENERAL LIBRARY ==================&-->
  <div class="Component_Content">
    <div class="Component_Content--left">
      <div class="Component_Content--left--Body">
        <div
          class="Component_Content--left--Body--Roles container-global-components"
        >
          <div class="Component_Content--left--Body--Roles--Title">
            <h2>Roles Generales</h2>
          </div>
          <div class="Component_Content--left--Body--Roles--Tree">
            <p-tree
              [value]="RoleOptions"
              selectionMode="checkbox"
              class="w-full md:w-30rem"
              [(selection)]="selectedRoles"
            ></p-tree>
          </div>
        </div>
        <div class="Card__Container--Item">
          <div
            class="Card__Container--Item--Check {{ ContainMail(User.email) }}"
          >
            <i class="fa-solid fa-check"></i>
          </div>

          <div class="Card__Container--Item--Body">
            <div class="Card__Container--Item--Body--Img">
              <span class="Card__Container--Item--Body--Img--Name">{{
                Format_Initials(User.Nombre)
              }}</span>
              <span class="Card__Container--Item--Body--Img--Point"></span>
            </div>
            <div class="Card__Container--Item--Body--Name">
              {{ User.Nombre }}
            </div>
            <div class="Card__Container--Item--Body--Description">
              {{ Format_LoginName(User.LoginName) }}
            </div>

            <div class="Card__Container--Item--Body--Info">
              <div class="Card__Container--Item--Body--Info--Section">
                <div class="Card__Container--Item--Body--Info--Section--Icon">
                  <i class="fa-regular fa-envelope"></i>
                </div>
                <div class="Card__Container--Item--Body--Info--Section--InfoS">
                  <div
                    class="Card__Container--Item--Body--Info--Section--InfoS--Title"
                  >
                    Correo electronico
                  </div>
                  <div
                    class="Card__Container--Item--Body--Info--Section--InfoS--Description"
                  >
                    {{ Format_Mail(User.email) }}
                  </div>
                </div>
              </div>
            </div>

            <div class="Card__Container--Item--Body--Info">
              <div class="Card__Container--Item--Body--Info--Section">
                <div class="Card__Container--Item--Body--Info--Section--Icon">
                  <i class="fa-regular fa-calendar"></i>
                </div>
                <div class="Card__Container--Item--Body--Info--Section--InfoS">
                  <div
                    class="Card__Container--Item--Body--Info--Section--InfoS--Title"
                  >
                    Fecha de modificacion
                  </div>
                  <div
                    class="Card__Container--Item--Body--Info--Section--InfoS--Description"
                  >
                    {{ Date_Format(User.Fecha_Modificacion) }}
                  </div>
                </div>
              </div>
            </div>

            <div class="Card__Container--Item--Body--Info">
              <div class="Card__Container--Item--Body--Info--Section">
                <div class="Card__Container--Item--Body--Info--Section--Icon">
                  <i class="fa-solid fa-fingerprint"></i>
                </div>
                <div class="Card__Container--Item--Body--Info--Section--InfoS">
                  <div
                    class="Card__Container--Item--Body--Info--Section--InfoS--Title"
                  >
                    Login name
                  </div>
                  <div
                    class="Card__Container--Item--Body--Info--Section--InfoS--Description"
                  >
                    {{ Format_LoginName(User.LoginName) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="Component_Content--right">
      <div class="container-global-components ConFLFIN">
        <div class="divider-butons-FM">
          <div (click)="SaveChanges()" class="btn btn-icon-text-left">
            <span class="text">Guardar Cambios</span
            ><i class="fa-solid fa-check-double"></i>
          </div>

          <div
            routerLink="/Dashboard/Admin/AdminUsersCDMS"
            class="btn btn-icon"
          >
            <i class="fa-solid fa-angles-left"></i>
          </div>
        </div>
        <div
          *ngIf="All_Roles_Of_User.length > 0 && LoadPage"
          class="Table-Lib Table-container-Global"
        >
          <p-table
            #dt
            [value]="All_Roles_Of_User"
            [(selection)]="Selected_All_Roles_Of_User"
            dataKey="id"
            [rowHover]="true"
            [rows]="5"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[5, 10, 15, 25, 50]"
            [paginator]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
            [filterDelay]="0"
            [globalFilterFields]="['Name', 'Description']"
          >
            <!--&================= SEARCH AND ALL Roles =================&-->
            <ng-template pTemplate="caption">
              <div class="SectionCreateTotal Section-Groups Table_NG">
                <div class="left-CT">
                  <div class="search inputText">
                    <i class="fa-solid fa-magnifying-glass"></i
                    ><input
                      [(ngModel)]="Input_Search"
                      type="text"
                      (input)="dt.filterGlobal(Input_Search, 'contains')"
                      placeholder="Buscar rol"
                    />
                  </div>
                </div>
                <div class="right-CT">
                  <div class="AllFiles">
                    Roles a los que pertenece el usuario:
                    <b>{{ All_Roles_Of_User.length }}</b>
                    <i class="fa-solid fa-users"></i>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <ng-container *ngFor="let Header of Headers_Roles">
                  <ng-container *ngIf="Header.Key_Header === 'NAME'">
                    <th pSortableColumn="Name" class="{{ Header.Key_Header }}">
                      <div class="Grid-Th">
                        <span>{{ Header.Name }}</span>
                        <span class="Icon-Th">
                          <p-sortIcon field="Name"></p-sortIcon>
                          <p-columnFilter
                            type="text"
                            field="Name"
                            display="menu"
                            class="ml-auto"
                          ></p-columnFilter>
                        </span>
                      </div>
                    </th>
                  </ng-container>

                  <ng-container *ngIf="Header.Key_Header === 'DESC'">
                    <th
                      pSortableColumn="Description"
                      class="{{ Header.Key_Header }}"
                    >
                      <div class="Grid-Th">
                        <span>{{ Header.Name }}</span>
                        <span class="Icon-Th">
                          <p-sortIcon field="Description"></p-sortIcon>
                          <p-columnFilter
                            type="text"
                            field="Description"
                            display="menu"
                            class="ml-auto"
                          ></p-columnFilter>
                        </span>
                      </div>
                    </th>
                  </ng-container>

                  <ng-container *ngIf="Header.Key_Header === 'LIBR'">
                    <th
                      pSortableColumn="Library"
                      class="{{ Header.Key_Header }}"
                    >
                      <div class="Grid-Th">
                        <span>{{ Header.Name }}</span>
                        <span class="Icon-Th">
                          <p-sortIcon field="Library"></p-sortIcon>
                          <p-columnFilter
                            type="text"
                            field="Library"
                            display="menu"
                            class="ml-auto"
                          ></p-columnFilter>
                        </span>
                      </div>
                    </th>
                  </ng-container>

                  <ng-container *ngIf="Header.Key_Header === 'OPTI'">
                    <th>
                      <!-- <i class="fa-regular fa-trash-can"></i> -->
                    </th>
                  </ng-container>
                </ng-container>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-All_Roles_Of_User>
              <tr>
                <td
                  *ngFor="let Header of Headers_Roles"
                  class="{{ Header.Key_Header }}"
                >
                  <ng-container *ngIf="Header.Key_Header === 'NAME'">
                    {{ All_Roles_Of_User.Name }}
                  </ng-container>

                  <ng-container *ngIf="Header.Key_Header === 'DESC'">
                    {{ All_Roles_Of_User.Description }}
                  </ng-container>

                  <ng-container *ngIf="Header.Key_Header === 'LIBR'">
                    {{ Library_String(All_Roles_Of_User.Library) }}
                  </ng-container>

                  <ng-container *ngIf="Header.Key_Header === 'OPTI'">
                    <button
                      (click)="See_Role_Library(All_Roles_Of_User)"
                      class="Btn-Option button-square"
                    >
                      <i class="fas fa-shield-alt"></i>
                    </button>
                    <button
                      (click)="Delete_User_To_Role(All_Roles_Of_User)"
                      class="Btn-Option button-square Remove"
                    >
                      <i class="fa-regular fa-trash-can"></i>
                    </button>
                  </ng-container>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td *ngIf="All_Roles_Of_User.length > 0" colspan="8">
                  Sin coincidencias.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div *ngIf="All_Roles_Of_User.length === 0 && LoadPage">
          <div class="Not-User">
            <div class="Img-Not">
              <img src="./assets/Global/Ilustrations/Not-User.png" alt="" />
            </div>
            <div class="Text-Not-User">
              ¡Aún no se han relacionado roles al usuario {{ User.Nombre }}!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="Content-Group">
    <div
      *ngIf="All_Group_Of_User.length > 0 && LoadPage"
      class="container-global-components ConFLFIN"
    >
      <div class="Table-Lib Table-container-Global">
        <p-table
          #dt
          [value]="All_Group_Of_User"
          [(selection)]="Selected_All_Group_Of_User"
          dataKey="id"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 15, 25, 50]"
          [paginator]="true"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
          [filterDelay]="0"
          [globalFilterFields]="['Nombre', 'Descripcion']"
        >
          <!--&================= SEARCH AND ALL Groups =================&-->
          <ng-template pTemplate="caption">
            <div class="SectionCreateTotal Section-Groups Table_NG">
              <div class="left-CT">
                <div class="search inputText">
                  <i class="fa-solid fa-magnifying-glass"></i
                  ><input
                    [(ngModel)]="Input_Search_G"
                    type="text"
                    (input)="dt.filterGlobal(Input_Search_G, 'contains')"
                    placeholder="Buscar grupo"
                  />
                </div>
              </div>
              <div class="right-CT">
                <div class="AllFiles">
                  Grupos a los que pertenece el usuario:
                  <b>{{ All_Group_Of_User.length }}</b>
                  <i class="fa-solid fa-users"></i>
                </div>
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <ng-container *ngFor="let Header of Headers_Group">
                <ng-container *ngIf="Header.Key_Header === 'NAME'">
                  <th pSortableColumn="Nombre" class="{{ Header.Key_Header }}">
                    <div class="Grid-Th">
                      <span>{{ Header.Name }}</span>
                      <span class="Icon-Th">
                        <p-sortIcon field="Nombre"></p-sortIcon>
                        <p-columnFilter
                          type="text"
                          field="Nombre"
                          display="menu"
                          class="ml-auto"
                        ></p-columnFilter>
                      </span>
                    </div>
                  </th>
                </ng-container>

                <ng-container *ngIf="Header.Key_Header === 'DESC'">
                  <th
                    pSortableColumn="Descripcion"
                    class="{{ Header.Key_Header }}"
                  >
                    <div class="Grid-Th">
                      <span>{{ Header.Name }}</span>
                      <span class="Icon-Th">
                        <p-sortIcon field="Descripcion"></p-sortIcon>
                        <p-columnFilter
                          type="text"
                          field="Descripcion"
                          display="menu"
                          class="ml-auto"
                        ></p-columnFilter>
                      </span>
                    </div>
                  </th>
                </ng-container>

                <ng-container *ngIf="Header.Key_Header === 'OPTI'">
                  <th>
                    <!-- <i class="fa-regular fa-trash-can"></i> -->
                  </th>
                </ng-container>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-All_Group_Of_User>
            <tr>
              <td
                *ngFor="let Header of Headers_Group"
                class="{{ Header.Key_Header }}"
              >
                <ng-container *ngIf="Header.Key_Header === 'NAME'">
                  {{ All_Group_Of_User.Nombre }}
                </ng-container>

                <ng-container *ngIf="Header.Key_Header === 'DESC'">
                  {{ All_Group_Of_User.Descripcion }}
                </ng-container>

                <ng-container *ngIf="Header.Key_Header === 'OPTI'">
                  <button
                    (click)="Delete_User_To_Group(All_Group_Of_User)"
                    class="Btn-Option button-square Remove"
                  >
                    <i class="fa-regular fa-trash-can"></i>
                  </button>
                </ng-container>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td *ngIf="All_Group_Of_User.length > 0" colspan="8">
                Sin coincidencias.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div
      *ngIf="All_Group_Of_User.length === 0 && LoadPage"
      class="container-global-components ConFLFIN"
    >
      <div class="Not-User">
        <div class="Img-Not">
          <img src="./assets/Global/Ilustrations/Not-User.png" alt="" />
        </div>
        <div class="Text-Not-User">
          ¡Aún no se han relacionado groupos al usuario {{ User.Nombre }}!
        </div>
      </div>
    </div>
  </div>
</div>
<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR RELATION USER =====================--->
<section class="Modal-Global" id="Modal_Relation_User">
  <div class="wrapper">
    <div class="Pro-popup-RU popup">
      <div class="Pro-inside-RU popup-inside">
        <div class="Pro-backgrounds-RU backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form>
        <div class="Pro-content-RU content">
          <button
            (click)="Toggle_Modal_Relation_User(false)"
            type="button"
            id="Btn-Close-Add-Top"
            class="Btn-Close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <div class="Content-Top">
            <h2>Relacionar rol al usuario</h2>
          </div>

          <div class="Content-body">
            <div class="SectionCreateTotal Section-Task">
              <div class="left-CT">
                <div class="Search inputText SearchBarCustom">
                  <i class="fa-solid fa-magnifying-glass"></i
                  ><input
                    [(ngModel)]="Input_Search_Role"
                    name="something"
                    type="text"
                    (keyup)="Search_User()"
                    (keyup)="Search_Enter($event)"
                    placeholder="Buscar rol (Mínimo 2 caracteres)"
                  />
                </div>
              </div>
              <div class="right-CT">
                <div class="AllFiles">
                  Total de roles sin relacionar:
                  <b>{{ All_Roles_CDMS.length }}</b>
                  <i class="fa-solid fa-users"></i>
                </div>
              </div>
            </div>

            <div class="Cardd">
              <div class="Cardd___Container">
                <div
                  *ngFor="let Role of All_Roles_CDMS_Copy; let i = index"
                  class="Cardd___Container--itemm"
                >
                  <div class="Cardd___Container--itemm--Bodyy">
                    <div class="Cardd___Container--itemm--Bodyy--Container">
                      <div
                        class="Cardd___Container--itemm--Bodyy--Container--Info"
                      >
                        <div
                          class="Cardd___Container--itemm--Bodyy--Container--Info--Title"
                        >
                          {{ Role.Name }}
                        </div>

                        <div
                          class="Cardd___Container--itemm--Bodyy--Container--Info--Description"
                        >
                          {{ Role.Description }}
                        </div>

                        <div
                          class="Cardd___Container--itemm--Bodyy--Container--Info--Permisions"
                        >
                          <div
                            class="Cardd___Container--itemm--Bodyy--Container--Info--Permisions--Container"
                          >
                            {{ Library_String(Role.Library) }}
                          </div>
                          <div
                            class="Cardd___Container--itemm--Bodyy--Container--Info--Permisions--Icon Add_Group"
                          >
                            <div (click)="Add_User_To_Role(Role)">
                              <span
                                class="Cardd___Container--itemm--Bodyy--Container--Info--Permisions--Icon--Tool-Tip"
                              >
                                Relacionar al rol
                              </span>
                              <i class="fa-solid fa-plus"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p-paginator
              (onPageChange)="onPageChange($event)"
              [first]="first"
              [rows]="rows"
              [totalRecords]="
                Input_Search_Role.length < 2
                  ? All_Roles_CDMS.length
                  : All_Roles_CDMS_Copy_Search.length
              "
            ></p-paginator>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL FOR RELATION USER =====================--->
<section class="Modal-Global" id="Modal_Relation_User_Group">
  <div class="wrapper">
    <div class="Pro-popup-RU popup">
      <div class="Pro-inside-RU popup-inside">
        <div class="Pro-backgrounds-RU backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form>
        <div class="Pro-content-RU content">
          <button
            (click)="Toggle_Modal_Relation_User_Group(false)"
            type="button"
            id="Btn-Close-Add-Top"
            class="Btn-Close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <div class="Content-Top">
            <h2>Relacionar grupo al usuario</h2>
          </div>

          <div class="Content-body">
            <div class="SectionCreateTotal Section-Task">
              <div class="left-CT">
                <div class="Search inputText SearchBarCustom">
                  <i class="fa-solid fa-magnifying-glass"></i
                  ><input
                    [(ngModel)]="Input_Search_Group"
                    name="something"
                    type="text"
                    (keyup)="Search_User_Group()"
                    (keyup)="Search_Enter_Group($event)"
                    placeholder="Buscar grupo (Mínimo 2 caracteres)"
                  />
                </div>
              </div>
              <div class="right-CT">
                <div class="AllFiles">
                  Total de grupos sin relacionar:
                  <b>{{ All_Groups_CDMS.length }}</b>
                  <i class="fa-solid fa-users"></i>
                </div>
              </div>
            </div>

            <div class="Cardd">
              <div class="Cardd___Container">
                <div
                  *ngFor="let Group of All_Groups_CDMS_Copy; let i = index"
                  class="Cardd___Container--itemm"
                >
                  <div class="Cardd___Container--itemm--Bodyy">
                    <div class="Cardd___Container--itemm--Bodyy--Container">
                      <div
                        class="Cardd___Container--itemm--Bodyy--Container--Info"
                      >
                        <div
                          class="Cardd___Container--itemm--Bodyy--Container--Info--Title"
                        >
                          {{ Group.Nombre }}
                        </div>

                        <div
                          class="Cardd___Container--itemm--Bodyy--Container--Info--Description"
                        >
                          Este grupo aún no tiene descripción, se le recomienda
                          asignarle alguna descripción al grupo para asi
                          identificarlo más rápido.
                        </div>
                        <div
                          class="Cardd___Container--itemm--Bodyy--Container--Info--Permisions--Icon group Add_Group"
                        >
                          <div (click)="Add_User_To_Group(Group)">
                            <span
                              class="Cardd___Container--itemm--Bodyy--Container--Info--Permisions--Icon--Tool-Tip"
                            >
                              Relacionar al grupo
                            </span>
                            <i class="fa-solid fa-plus"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p-paginator
              (onPageChange)="onPageChangeGroup($event)"
              [first]="first_group"
              [rows]="rows_group"
              [totalRecords]="
                Input_Search_Group.length < 2
                  ? All_Groups_CDMS.length
                  : All_Groups_CDMS_Copy_Search.length
              "
            ></p-paginator>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
